import * as React from 'react';
import { ThemeProvider as ThemeProvider$2 } from '@emotion/react';
import { GlobalStyles } from '../utils/globalStyles.js';
import customTheme, { mergeThemes } from '../utils/theme.js';

var ThemeProvider = function ThemeProvider(_ref) {
  var theme = _ref.theme,
    children = _ref.children;
  var siteTheme = mergeThemes(customTheme, theme);
  return /*#__PURE__*/React.createElement(ThemeProvider$2, {
    theme: siteTheme
  }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(GlobalStyles, {
    theme: siteTheme
  }), children));
};
var ThemeProvider$1 = ThemeProvider;

export { ThemeProvider$1 as default };
//# sourceMappingURL=ThemeProvider.js.map
